import { AgentBookingWebService as BookingWebService } from '@linktivity/gds-neo';

export const BookingType =
  BookingWebService.ListBookingsWithPageBookingTypeEnum;
export type BookingType = BookingWebService.ListBookingsWithPageBookingTypeEnum;

export const BulkBookingModelStatus = BookingWebService.BulkBookingModelStatus;
